import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Button } from "@fronterahealth/frontera-ui-components";

export enum CopyToClipboardButtonVariant {
  Icon = "icon",
  Text = "text",
}

interface CopyToClipboardButtonProps {
  text: string;
  variant?: CopyToClipboardButtonVariant;
  label?: string;
  copiedLabel?: string;
  className?: string;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  text,
  variant = CopyToClipboardButtonVariant.Icon,
  label = "Copy",
  copiedLabel = "Copied!",
  className,
}) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  if (variant === CopyToClipboardButtonVariant.Text) {
    return (
      <Button
        onClick={copyToClipboard}
        variant="primary"
        buttonStyle="ghost"
        text={copied ? copiedLabel : label}
        className={className}
      />
    );
  }

  return (
    <div className="relative">
      <button
        onClick={(e) => {
          e.stopPropagation();
          copyToClipboard();
        }}
        className={className || "rounded p-0.5 text-text-secondary hover:bg-limestone-200 hover:text-text-primary"}
      >
        <ClipboardDocumentIcon className="h-4 w-4" />
      </button>
      {copied && (
        <div className="absolute -top-8 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-sm bg-gray-800 px-2 py-1 text-xs text-white">
          Copied!
        </div>
      )}
    </div>
  );
};
